import { Button, Col, Row, Rate, Tooltip, Popover, Modal } from 'antd';
import expertIcon from '../../assets/images/profile_placeholder.png';
import { useState, useEffect } from 'react';
import { createMarkup, breakName, getExpertiyInIndustery } from '../../helpers/functions';
import { EnvironmentOutlined, EyeOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {
  nameRecommendationConstantForToolTip,
  recommendationReportTooltips,
} from '../../helpers/constant';
import { useDispatch } from 'react-redux';
import { getRequestAPI, postRequestAPI, putRequestAPI } from '../../helpers/service';
import TextDisplayModal from './TextDisplayModal';
import '../../assets/scss/recommendedExpertCard.scss';
import { set } from 'lodash';
import Loader from './Loader';

const RecommendedExpertCard = ({
  expert = {},
  matchRank = 0,
  questionDetails,
  messageButton = null,
  localStorageKey,
  setBackToRecommendation,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [expertRates, setExpertRates] = useState(null);
  const [isLoadingRates, setIsLoadingRates] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [evalLoading, setLoading] = useState(false);
  const [evalReport, setEvalReport] = useState(null);
  async function getEvalReport(id) {
    try {
      setLoading(true);
      const response = await postRequestAPI({
        //url: `expert/generate-proposal/${id}/${questionDetails.id}`,
        url: `get-proposal-for-expert`,
        data: { question_id: questionDetails.id, expert_id: id },
      });
      if (response.status === 200) {
        setEvalReport(response.data);
        setLoading(false);
        setIsModalVisible(true);
      }
    } catch (error) {
      setLoading(false);
    }
  }
  useEffect(() => {
    const fetchExpertRates = async () => {
      if (expert?.id && !expertRates && !isLoadingRates) {
        try {
          setIsLoadingRates(true);
          const response = await putRequestAPI({
            url: 'services-and-rate',
            data: { expert_id: expert.id },
          });

          if (response.status === 200 && response.data) {
            setExpertRates(response.data.data || []);
          }
        } catch (error) {
          console.error('Error fetching expert rates:', error);
        } finally {
          setIsLoadingRates(false);
        }
      }
    };

    // fetchExpertRates();
  }, []);

  const {
    id,
    first_name = '',
    last_name = '',
    bio = '',
    avatar = null,
    rating = 0,
    category = [],
    locations = [],
    total_rank = 0,
    total_reviews = 0,
    total_rank_fields = '',
    description = '',
    pricing = {},
  } = expert || {};

  const rankFields = total_rank_fields.split(',').map(Number);
  const [
    new_cat_rank = 0,
    new_subcat_rank = 0,
    new_rev_exp_rank = 0,
    new_gen_exp_rank = 0,
    new_seniority_rank = 0,
    new_location_rank = 0,
    new_rating_rank = 0,
    new_language_rank = 0,
    new_availability_rank = 0,
  ] = rankFields;

  const avgRank = Number(
    (
      (new_cat_rank +
        new_gen_exp_rank +
        new_location_rank +
        new_rating_rank +
        new_language_rank +
        new_availability_rank) /
      6
    ).toFixed(2),
  );

  const averageRating = new_rating_rank || 0;
  const totalReviews = new_rating_rank || 0;
  const review_snippet = description;
  const truncatedText =
    review_snippet?.length > 150
      ? review_snippet
        .replace(/\n{2,}/g, '. ')
        .substring(0, 125)
        .split(' ')
        .slice(0, -1)
        .join(' ') + '...'
      : review_snippet;

  const getOrdinalSuffix = n => {
    if (!n) return '0th';
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const handleSelectExpert = id => {
    setBackToRecommendation(false);
    dispatch({
      type: 'POST_CLIENT_ACCEPT_OR_REJECT_EXPERT_REQUEST',
      formData: {
        question_id: questionDetails.id,
        is_recommended: 1,
        expert_id: id,
      },
    });
    if (!localStorage.getItem(localStorageKey)) {
      localStorage.setItem(localStorageKey, 'true');
    }
  };

  const handleMessageExpert = id => {
    setBackToRecommendation(false);
    messageButton();
    if (!localStorage.getItem(localStorageKey)) {
      localStorage.setItem(localStorageKey, 'true');
    }
    // navigate(`/dashboard/customer/messages`);
  };

  const Circle = ({ percentage, label, heading, info }) => (
    <div className="circle-wrapper">
      <div style={{ position: 'absolute', top: '-10px', right: '0' }}>
        <Popover
          content={
            <Row style={{ width: '100%', justifyContent: 'space-evenly' }}>
              <Col
                span={7}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'start',
                  border: '1px dashed #807e7e',

                  // padding: '1rem',
                  borderRadius: '.5rem',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    backgroundColor: 'rgb(227, 227, 227)',
                    borderBottom: '1px dashed #807e7e',
                    padding: '1rem 0rem',
                    textAlign: 'center',
                  }}
                >
                  {/* <p>Perfect</p> */}
                  <span>Perfect</span>
                </div>

                <div
                  style={{
                    width: '100%',
                    borderBottom: '1px dashed #807e7e',
                    padding: '1rem 0rem',
                    textAlign: 'center',
                  }}
                >
                  <span>{heading && heading !== 'Language' ? '100%-70%' : '100%'}</span>
                </div>
                <div style={{ width: '100%', padding: '1rem' }}>
                  <span>{info['perfect']}</span>
                </div>
              </Col>
              {heading && heading !== 'Language' ? (
                <Col
                  span={7}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    border: '1px dashed #807e7e',

                    // padding: '1rem',
                    borderRadius: '.5rem',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      backgroundColor: 'rgb(227, 227, 227)',
                      borderBottom: '1px dashed #807e7e',
                      padding: '1rem 0rem',
                      textAlign: 'center',
                    }}
                  >
                    {/* <p>Perfect</p> */}
                    <span>Moderate</span>
                  </div>

                  <div
                    style={{
                      width: '100%',
                      borderBottom: '1px dashed #807e7e',
                      padding: '1rem 0rem',
                      textAlign: 'center',
                    }}
                  >
                    <span>69%-35%</span>
                  </div>
                  <div style={{ width: '100%', padding: '1rem' }}>
                    <span>{info['moderate']}</span>
                  </div>
                </Col>
              ) : (
                ''
              )}
              <Col
                span={7}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'start',
                  border: '1px dashed #807e7e',

                  // padding: '1rem',
                  borderRadius: '.5rem',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    backgroundColor: 'rgb(227, 227, 227)',
                    borderBottom: '1px dashed #807e7e',
                    padding: '1rem 0rem',
                    textAlign: 'center',
                  }}
                >
                  {/* <p>Perfect</p> */}
                  <span>Unsure</span>
                </div>

                <div
                  style={{
                    width: '100%',
                    borderBottom: '1px dashed #807e7e',
                    padding: '1rem 0rem',
                    textAlign: 'center',
                  }}
                >
                  <span>{heading && heading !== 'Language' ? '0%-34%' : '0%'}</span>
                </div>
                <div style={{ width: '100%', padding: '1rem' }}>
                  <span>{info['unsure']}</span>
                </div>
              </Col>
            </Row>
          }
          style={{ width: '25rem !important' }}
          // title={capitalizeFirstLetter(heading == 'Service Type' ? sub_category || heading : heading)}
          trigger="click"
        >
          {total_reviews > 0 && (
            <InfoCircleOutlined style={{ cursor: 'pointer', marginLeft: '4px' }} />
          )}
        </Popover>
      </div>

      <div style={{ width: '45px', height: '45px', marginBottom: '4px' }}>
        <CircularProgressbar
          value={Math.round(percentage)}
          text={`${Math.round(percentage)}%`}
          styles={buildStyles({
            textColor: '#4071ca',
            pathColor: '#4071ca',
            trailColor: '#e6e6e6',
            textSize: '24px',
          })}
          strokeWidth={10}
        />
      </div>
      <div className="circle-label">{label}</div>
    </div>
  );

  if (!expert || Object.keys(expert).length === 0) {
    return (
      <div className="expert-card">
        <div>No expert data available</div>
      </div>
    );
  }

  return (
    <div className="expert-card">
      <div className="expert-header">
        <div className="expert-avatar-container">
          <div className="expert-avatar-wrapper">
            <img
              alt="expert"
              height={80}
              width={80}
              src={avatar || expertIcon}
              loading="lazy"
              className="expert-avatar"
            />
          </div>
          <Button
            type="default"
            size="small"
            icon={<EyeOutlined />}
            // onClick={() => navigate(`/find-expert-detail/${id}`)}
            onClick={() => navigate(`/find-expert-detail/${id}`)}
            className="view-profile-button"
          >
            View Profile
          </Button>
        </div>
        <div className="expert-info">
          <div className="expert-title">
            <div className="match-badge">
              {getOrdinalSuffix(matchRank)} Match - {total_rank.toFixed(1)} pts
            </div>

            <div className="pricing-info">
              <span className="price-range">
                <span className="currency-symbol">CA$</span>
                {pricing?.rate_from} - {pricing?.rate_to}
                <span className="rate-type">{pricing?.pricing_type}</span>
                {/* {expertRates[0]?.rate_from} - {expertRates[0]?.rate_to}
                  <span className="rate-type">{expertRates[0]?.rate_type?.name}</span> */}
              </span>
            </div>

            <div className="expert-name">
              <Tooltip
                title={nameRecommendationConstantForToolTip?.title || ''}
                color={nameRecommendationConstantForToolTip?.color}
              >
                {breakName(first_name, last_name)}
              </Tooltip>
              <Tooltip title={recommendationReportTooltips.location}>
                <EnvironmentOutlined style={{ color: '#1890ff', marginLeft: '5px' }} />
                <span className="expert-category">{expert?.default_location?.[0]?.name}</span>
              </Tooltip>
            </div>
          </div>
          <div className="expert-category" style={{ display: 'flex', flexWrap: 'wrap' }}>
            {category.map((item, index) => {
              return (
                <span key={index}>
                  {item?.name}
                  {index !== category.length - 1 ? ',' : '.'}
                </span>
              );
            })}
          </div>
          <div className="expert-location">
            <EnvironmentOutlined style={{ color: '#1890ff' }} />
            <Tooltip
              title={
                locations.length > 0
                  ? recommendationReportTooltips.locationExpertServes +
                  locations.map(loc => loc.name).join(', ')
                  : 'Location not specified'
              }
            >
              <span className="location-text">
                {locations.length > 0
                  ? locations.map(loc => loc.name).join(', ')
                  : 'Location not specified'}
              </span>
            </Tooltip>
          </div>
        </div>
      </div>

      <Row gutter={[24, 24]}>
        {[
          {
            key: 'experience',
            show: getExpertiyInIndustery(new_gen_exp_rank) > 0,
            heading: 'Experience',
            tooltip:
              expert?.question_detail?.sector?.industry?.reduce?.(
                (total, exp) => total + (exp.number_of_years || 0),
                0,
              ) ?? '',
            info: {
              perfect:
                'Extensive hands-on experience in the field with consistent, proven results.',
              moderate: 'Solid track record with increasing responsibility and results over time.',
              unsure: 'Some familiarity or early-stage exposure to the field.',
            },
            percentage: getExpertiyInIndustery(new_gen_exp_rank),
            label: 'Experience',
          },
          {
            key: 'serviceType',
            show: new_subcat_rank > 0,
            heading: 'Service Type',
            tooltip: expert?.question_detail?.sub_category?.name || '',
            info: {
              perfect: `Deep expertise in ${'subcategory'}.`,
              moderate: `Experience in ${'subcategory'}.`,
              unsure: `Limited exposure in ${'subcategory'}.`,
            },
            percentage: new_subcat_rank,
            label: 'Service Type',
          },
          {
            key: 'industry',
            show: new_cat_rank > 0,
            heading: 'Industry',
            tooltip: expert?.question_detail?.category?.name || '',
            info: {
              perfect: 'Extensive experience specific to the industry.',
              moderate: 'Proven track record in related industries.',
              unsure: 'Some familiarity with the industry.',
            },
            percentage: new_cat_rank,
            label: 'Industry',
          },
          {
            key: 'reviews',
            show: rating > 0,
            heading: 'Reviews',
            tooltip: expert?.question_detail?.question_review?.rating || '',
            info: {
              perfect: 'Consistently outstanding reviews.',
              moderate: 'Mostly positive reviews with minor issues.',
              unsure: 'Mixed reviews or limited feedback available.',
            },
            percentage: (rating * 100) / 5,
            label: 'Reviews',
          },
          {
            key: 'location',
            show: new_location_rank > 0,
            heading: 'Location',
            tooltip: expert?.question_detail?.location?.name,
            info: {
              perfect: 'Located in the same province.',
              moderate: 'Located in a neighboring province.',
              unsure: 'Located in a different region of Canada.',
            },
            percentage: new_location_rank,
            label: 'Location',
          },
          {
            key: 'language',
            show: new_language_rank > 0,
            heading: 'Language',
            tooltip: expert?.question_detail?.language?.name || '',
            info: {
              perfect: 'Communicate in one or more of your other language(s).',
              moderate: 'pending',
              unsure: 'Do not communicate in your other language(s).',
            },
            percentage: new_language_rank,
            label: 'Language',
          },
          {
            key: 'availability',
            show: new_availability_rank > 0,
            heading: 'Availability',
            tooltip: new_availability_rank,
            info: {
              perfect: 'High availability; more time to dedicate to new clients.',
              moderate: 'Moderate availability; balancing other clients.',
              unsure: 'Limited availability; minimal time for new clients.',
            },
            percentage: new_availability_rank,
            label: 'Availability',
          },
        ]
          .filter(item => item.show)
          .map(item => (
            <Col span={6} key={item.key}>
              {item.tooltip ? (
                <Tooltip title={item.tooltip}>
                  <div>
                    <Circle
                      heading={item.heading}
                      info={item.info}
                      percentage={item.percentage}
                      label={item.label}
                    />
                  </div>
                </Tooltip>
              ) : (
                <Circle
                  heading={item.heading}
                  info={item.info}
                  percentage={item.percentage}
                  label={item.label}
                />
              )}
            </Col>
          ))}
      </Row>

      <div className="expert-bio">
        {!!total_reviews && (
          <div className="rating-container">
            <Rate disabled value={rating} allowHalf style={{ fontSize: '1em' }} />
            <span className="review-count">
              {total_reviews > 0 ? `(${total_reviews} reviews)` : 'No reviews yet'}
            </span>
          </div>
        )}

        {/* {review_snippet && ( */}
        <>
          <div className="bio-text" dangerouslySetInnerHTML={createMarkup(truncatedText)} />
          {/* {review_snippet.length > 150 && ( */}
          <Button
            type="primary"
            // className="text-end"
            onClick={() => getEvalReport(id)}
          >
            Ai Evaluatation
          </Button>
          {/* )} */}
          <TextDisplayModal
            visible={isModalVisible}
            setVisible={setIsModalVisible}
            content={review_snippet}
            title={`${first_name}'s Evaluation Report`}
          />
        </>
        {/* )} */}
        {/* {matchRank > 3 && (
          <>
            {!evalLoading ? (
              <Button type="link" className="read-more-button" onClick={() => getEvalReport(id)}>
                Read full match explanation...
              </Button>
            ) : (
              <Loader />
            )}
          </>
        )} */}
      </div>

      <Row gutter={[16, 16]} justify="center" className="action-buttons">
        <Col span={12}>
          <Tooltip title={recommendationReportTooltips.selectButton}>
            <Button type="primary" onClick={() => handleSelectExpert(id)} className="select-button">
              Select
            </Button>
          </Tooltip>
        </Col>
        <Col span={12}>
          <Button
            onClick={() => handleMessageExpert(id)}
            className="message-button"
            disabled={questionDetails?.expert.id != expert?.id}
            title={
              questionDetails?.expert.id != expert?.id ? 'Select expert to enable messaging' : ''
            }
          >
            Message
          </Button>
        </Col>
      </Row>
      {evalReport && (
        <TextDisplayModal
          visible={isModalVisible}
          setVisible={setIsModalVisible}
          content={evalReport.generatedText}
          title={`${first_name}'s Evaluation Report`}
        />
      )}
    </div>
  );
};

export default RecommendedExpertCard;
